import React, { useCallback, useState } from 'react';

import { Button, Form, Input, Modal, Switch, Typography } from 'antd';

import { useUserStore } from 'v2/store/User';

import LinksClipBoard from './LinksClipBoard';

interface IProps {
  open: boolean;
  handleClose: () => void;
  baseUrl: string;
  baseUrlChk?: string;
  isProducer?: boolean;
}

const UrlCreator: React.FC<IProps> = ({ open, handleClose, baseUrl, baseUrlChk, isProducer }) => {
  const [utmSource, setUtmSource] = useState('');
  const [utmMedium, setUtmMedium] = useState('');
  const [utmContent, setUtmContent] = useState('');
  const [utmCampaign, setUtmCampaign] = useState('');
  const [redirect, setRedirect] = useState(false);

  const { currentUserId } = useUserStore(({ user }) => ({ currentUserId: user.id }));

  const createParameters = useCallback(
    (baseUrlParam: string) => {
      const parameters: string[] = [];
      let firstParameter = '?';

      if (utmSource) {
        parameters.push('utm_source=' + utmSource);
      }

      if (utmMedium) {
        parameters.push('utm_medium=' + utmMedium);
      }

      if (utmContent) {
        parameters.push('utm_content=' + utmContent);
      }

      if (utmCampaign) {
        parameters.push('utm_campaign=' + utmCampaign);
      }

      if (redirect) {
        parameters.push('redirecionar=S');
      }

      if (!isProducer) {
        parameters.push('a=' + currentUserId);
      }

      if (parameters.length === 0) {
        return '';
      }

      if (baseUrlParam.indexOf('a=') >= 0) {
        firstParameter = '&';
      }

      return firstParameter + parameters.join('&');
    },
    [utmSource, utmMedium, utmContent, utmCampaign, redirect, isProducer, currentUserId]
  );

  const urlsCheckouts = {
    urlChk: baseUrlChk ? baseUrlChk + createParameters(baseUrlChk) : '',
    urlSun: baseUrl + createParameters(baseUrl)
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title={
        <div>
          <div>Adicionar UTMs</div>
          <Typography.Text type='secondary' className='text-sm font-normal'>
            Crie sua URL para rastrear melhor seus resultados.
          </Typography.Text>
        </div>
      }
      width={720}
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='primary' onClick={handleClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <Form layout='vertical' className='flex flex-col gap-1'>
        <div className='grid grid-cols-1 gap-x-4 md:grid-cols-2'>
          <Form.Item label='Origem da campanha (utm_source)' extra='Ex: google, facebook, newsletter' className='!mb-3'>
            <Input size='small' value={utmSource} onChange={(e: any) => setUtmSource(e.target.value)} />
          </Form.Item>
          <Form.Item
            label='Mídia da campanha (utm_medium)'
            extra='Ex: mídia de marketing: cpc, banner, e-mail'
            className='!mb-3'
          >
            <Input size='small' value={utmMedium} onChange={(e: any) => setUtmMedium(e.target.value)} />
          </Form.Item>
          <Form.Item label='Conteúdo da campanha (utm_content)' extra='Ex: bannerPromocao, bannerBonus' className='!mb-3'>
            <Input size='small' value={utmContent} onChange={(e: any) => setUtmContent(e.target.value)} />
          </Form.Item>
          <Form.Item label='Origem da campanha (utm_campaign)' extra='Ex: CampanhaDeLancamento' className='!mb-3'>
            <Input size='small' value={utmCampaign} onChange={(e: any) => setUtmCampaign(e.target.value)} />
          </Form.Item>
        </div>

        <div className='mb-4 flex items-center gap-2'>
          <Switch size='small' checked={redirect} onChange={(checked: boolean) => setRedirect(checked)} />
          <Typography.Text>Encaminhar UTMs do link para a URL do produtor</Typography.Text>
        </div>

        <LinksClipBoard urlChk={urlsCheckouts.urlChk} urlSun={urlsCheckouts.urlSun} />
      </Form>
    </Modal>
  );
};

export default UrlCreator;
